import React from 'react';
import { Title } from 'react-admin';
import ManageView from './components/ManageView';
import { useApi } from './api';
import useFirebaseToken from '../../bitComponents/utils/hooks/useFirebaseToken';

const Manage = () => {
  const { token } = useFirebaseToken();
  const { syncBqToPgNames, download, uploadCsv } = useApi(
    '/electric-car-names',
    token
  );
  if (!token) return <></>;
  return (
    <>
      <Title title={'ניהול שמות רכבים חשמליים'}>ניהול שמות רכבים חשמליים</Title>
      <ManageView
        syncBqToPgNames={syncBqToPgNames}
        download={download}
        uploadCsv={uploadCsv}
        resourceTitle="שמות רכבים חשמליים"
        title={'ניהול שמות רכבים חשמליים'}
        subtitle={'ייצוא, העלאה וסנכרון שמות רכבים חשמליים'}
      />
    </>
  );
};

export default Manage;
